(function () {
  'use strict';

  angular
    .module('app.page-roles', []);
})();
